import AuthBackgroundImage from "./images/asset-background.png";
import email from "./icons/email.png";
import help from "./icons/help.png";
import white_forward_arrow from "./icons/arrow-white.png";
import dark_back_arrow from "./icons/arrow-back-dark.png";
import ghs_logo from "./images/ghs-logo.jpg";
import green_forward_arrow from "./icons/arrow-forward-green.png";
import dashboard from "./icons/chart.png";
import devices from "./icons/computer-desktop.png";
import users from "./icons/users.png";
import Programmes from "./icons/building.png";
import maintenance from "./icons/maintainance.png";
import roles_permissions from "./icons/roles.png";
import bell from "./icons/bell.png";
import settings from "./icons/settings.png";
import dummy_user_img from "./images/dummy-user.png";
import logout from "./icons/logout.png";
import search from "./icons/search.png";
import funnel from "./icons/funnel.png";
import plus_white from "./icons/plus-white.png";
import columns from "./icons/columns.svg";
import empty_db from "./images/no-item.png";
import empty_search from "./images/search-empty.png";
import open_folder from "./icons/open-folder.png";
import chevron_down from "./icons/chevron-down.png";
import under_construction from "./images/under-construction.jpg";
import maintenance_green from "./icons/maintenance-green.png";
import programs_green from "./icons/building-green.png";
import dashboard_green from "./icons/pie-green.png";
import roles_green from "./icons/roles-green.png";
import users_green from "./icons/users-green.png";
import devices_green from "./icons/desktop-green.png";
import settings_green from "./icons/settings-green.png";
import shield from "./icons/shield.png";
import success from "./icons/success.png";
import warning from "./icons/warning.png";
import danger from "./icons/danger.png";
import close from "./icons/close.png";
import person_1 from "./images/person-1.png";
import person_2 from "./images/person-2.png";
import person_3 from "./images/person-3.png";
import filter_lines from "./icons/Filters.png";
import close_green from "./icons/close-green.png";
import more from "./icons/more.png";
import green_check from "./icons/green-check.png";
import delete_item from "./icons/delete.png";
import edit_item from "./icons/edit.png";
import edit_green from "./icons/pen-green.png";
import delete_green from "./icons/trash-green.png";
import folder_white from "./icons/folder-white.png";
import phone_call from "./icons/phone-call.png";
import calender_icon from './icons/calender-icon.png'
import calender_icon_fill from './icons/calender-icon-fill.png';
import delete_icon from './icons/delete_icon.png';
import arrow_left_icon from './icons/arrow-left-icon.png';
import arrow_right_icon from './icons/arrow-right-icon.png';
import image_upload_icon from './icons/image-upload.png';
import pdf_icon from './icons/pdf-icon.png';
import csv_icon from './icons/csv-icon.png';




export const DamsAppAsset = {
  image: {
    AuthBackground: AuthBackgroundImage,
    ghs_logo: ghs_logo,
    empty_db: empty_db,
    empty_search: empty_search,
    under_construction: under_construction,
  },

  icons: {
    email: email,
    help: help,
    white_forward_arrow: white_forward_arrow,
    dark_back_arrow: dark_back_arrow,
    green_forward_arrow: green_forward_arrow,
    dashboard: dashboard,
    devices: devices,
    users: users,
    Programmes: Programmes,
    maintenance: maintenance,
    roles_permissions: roles_permissions,
    notifications: phone_call,
    settings: settings,
    dummy_user_img: dummy_user_img,
    logout: logout,
    search: search,
    filter: funnel,
    columns: columns,
    plus_white: plus_white,
    save: open_folder,
    select_arrow: chevron_down,
    dashboard_green: dashboard_green,
    roles_green: roles_green,
    devices_green: devices_green,
    programs_green: programs_green,
    maintenance_green: maintenance_green,
    users_green: users_green,
    settings_green: settings_green,
    danger: danger,
    warning: warning,
    success: success,
    shield: shield,
    close: close,
    person_1: person_1,
    person_2: person_2,
    person_3: person_3,
    filter_lines: filter_lines,
    close_green: close_green,
    more: more,
    green_check: green_check,
    delete_item: delete_item,
    edit_item: edit_item,
    edit_green: edit_green,
    delete_green: delete_green,
    folder_white: folder_white,
    support: phone_call,
    calender_icon:calender_icon,
    calender_icon_fill:calender_icon_fill,
    delete_icon:delete_icon,
    arrow_left_icon:arrow_left_icon,
    arrow_right_icon:arrow_right_icon,
    image_upload_icon: image_upload_icon,
    pdf_icon: pdf_icon,
    csv_icon: csv_icon
    

  },
};
